import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';

const CartSkeleton = () => {
    const gridItems = Array.from({ length: 3 });

    return (
        <Grid container spacing={2}>
            {gridItems.map((_, index) => (
                <Grid item size={{xs:12}}>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        animation="wave"
                        height={120}
                        style={{borderRadius:16}}
                    />
                </Grid>
            ))}
            <Grid item size={{xs:12}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={27}
                    style={{borderRadius:16}}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={27}
                    style={{borderRadius:16}}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={27}
                    style={{borderRadius:16}}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={50}
                    style={{borderRadius:16}}
                />
            </Grid>
        </Grid>
    );
};

export default CartSkeleton;
